import { render, staticRenderFns } from "./AppStatusLink.vue?vue&type=template&id=62b5c712&scoped=true&"
var script = {}
import style0 from "./AppStatusLink.vue?vue&type=style&index=0&id=62b5c712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5c712",
  null
  
)

export default component.exports